import { freddyTheme } from '@coolblue-development/freddy';
const virtualAgentButtonStyles = {
    position: 'relative',
    transition: `${freddyTheme.motionDuration.medium} ${freddyTheme.motionEasing.easeInOut}`,
    background: `linear-gradient(120deg, ${freddyTheme.color.background.interactiveMainHovered}, ${freddyTheme.color.background.interactiveMainBase}, #39B6FE)`,
    backgroundSize: '200%',
    backgroundPosition: '100% 0',
    pointerEvents: 'auto',
    width: '100%',
    [freddyTheme.breakpoint.minWidth('md')]: {
        width: 'auto',
    },
    '&:hover': {
        background: `linear-gradient(120deg, ${freddyTheme.color.background.interactiveMainHovered}, ${freddyTheme.color.background.interactiveMainBase}, #39B6FE)`,
        backgroundSize: '200%',
        backgroundPosition: '10% 0',
    },
    '&:active': {
        background: `linear-gradient(120deg, ${freddyTheme.color.background.interactiveMainHovered}, ${freddyTheme.color.background.interactiveMainBase}, #39B6FE)`,
        backgroundSize: '200%',
        backgroundPosition: '10% 0',
    },
};
const videoContainerStyles = {
    position: 'absolute',
    width: '80px',
    height: '80px',
    top: '-8px',
    left: '50%',
    transform: 'translateX(-50%)',
    [freddyTheme.breakpoint.minWidth('md')]: {
        top: '-16px',
        width: '120px',
        height: '120px',
    },
    'video:first-of-type': {
        position: 'absolute',
        width: '200%',
        height: '200%',
        top: '-50%',
        left: '-50%',
        opacity: 0.2,
        filter: 'blur(30px)',
        pointerEvents: 'none',
        zIndex: 0,
    },
    'video:nth-of-type(2)': {
        width: '100%',
        height: '100%',
        position: 'relative',
        zIndex: 1,
        [freddyTheme.breakpoint.minWidth('md')]: {
            width: '100%',
            height: '100%',
        },
    },
};
export { videoContainerStyles, virtualAgentButtonStyles };
//# sourceMappingURL=VirtualAgentEntrance.styled.js.map